import React from "react";

interface SectionWrapper {
    title: string;
    subtitle?: string | React.ReactNode;
    divided?: boolean;
    labelStyle?: object;
}

const SectionWrapper: React.FC<SectionWrapper> = ({ title, subtitle, divided, children, labelStyle }) => (
    <div>
        {divided && <hr className="horizontal_rule" />}
        <h2 style={labelStyle}>{title}</h2>
        {subtitle && <span className="subtitle">{subtitle}</span>}
        {children}
    </div>
);

export { SectionWrapper };
